import { userHasRole, userHasPermission } from "../utils/policyUtils.js";

export default {
  viewAny: ({ user }) => {
    return userHasRole(user, ["sysadmin", "makler_buchhaltung"]);
  },
  exportAny: ({ user }) => {
    return (
      userHasRole(user, ["sysadmin", "makler_buchhaltung"]) &&
      userHasPermission(user, "buchung_export")
    );
  },
};
